import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import VideoPlayer from 'shared/video/VideoPlayer';
import { initModal } from 'shared/actions/modal.action';
import Dim from 'web/components/common/modal/common/Dim';
import styles from './VideoPageContainer.scss';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

function VideoPageContainer({ data = {} }) {
  const dispatch = useDispatch();
  const { playstatus } = useSelector(state => state.shared.videoplay);
  const closeModal = () => {
    dispatch(initModal());
  };
  console.log({ playstatus });

  return (
    <div
      className={cx('VideoPage')}
      onClick={playstatus !== 'playing' ? () => closeModal() : ''}
    >
      <div style={{ height: '100vh !important' }}>
        <VideoPlayer
          playerId={data.videoId}
          mediaUrl={data.mediaUrl}
          videoIndex={data.videoIndex}
          autoplay={true}
          controls={true}
          fullscreen={true}
          setPlayer={() => {}}
          updatePlayerState={() => {}}
          closeModal={closeModal}
          handleCloseVideo={data.handleCloseVideo}
        />
      </div>
    </div>
  );
}

export default VideoPageContainer;
